export default "__VITE_ASSET__Cj5SBCKe__"